import React from 'react'
import Hero from '../components/hero/hero'
import Services from '../components/services/services'
import Process from '../components/process/process'
import Specially from '../components/specially/specially'
import Engagement from '../components/engagementmodels/engagement'
import Achivments from '../components/achivments/achivments'
import Portfolio from '../components/portfolio/portfolio'
import Talktous from '../components/talktous/talktous'
import Connectwithus from '../components/connectwithus/connectwithus'
import Footer from '../components/footer/footer'
import Expertise from '../components/expertise/expertise'

function Main() {
    return (
        <div>
            <Hero />
            <Services />
            <Process />
            <Expertise />
            <Specially />
            <Engagement />
            <Achivments />
            <Portfolio />
            <Talktous />
            <Connectwithus />
            <Footer />
        </div>
    )
}

export default Main